import "../LibraryBoxBattle.scss";
import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import NP from "../../../1. Core/NP";
import DataTable from "../../../1. Core/Controls/DataTable/DataTable";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import './EditBoutStatisticsDialog.scss'
import Menu from "../../../1. Core/Controls/Menu/Menu";
import {IBattleEvent} from "../../Util";
import {IBattle, MMAEvent, SportType} from "../../types";
import Button from "../../../1. Core/Controls/Button/Button";

import {getBoxEventsColumns} from "./func";
import EditMMAEventDialog from "../../../9. DataInput/EditMMAEventDialog";
import CheckBox from "../../../1. Core/Controls/CheckBox/CheckBox";
import EditEventDialog from "./EditEventDialog";
import TabControl from "../../../1. Core/Controls/TabControl/TabControl";
import JudgePanel from "./JudgePanel";


export default class EditBoutStatisticsDialog extends Dialog {
	private _Battle: IBattle;

	private _Offset: number
	private _Count: number
	private _AllCount: number

	private _dataTable: DataTable;
	private _isOnline: boolean;
	private _onlineId: any;
	private _lastLoadedEventId: number;
	private _refreshAll: boolean;
	_tabs: TabControl;
	private _judgePanel: JudgePanel;

	constructor(settings: any)
	{
		super(settings);
	}

	_initFields(settings: object)
	{
		this._Battle = null;

		super._initFields(settings);
		this._Width = null;
		this._Offset = 0;
		this._Count = 100;
		this._AllCount = 100;
		this._Mode = 'FullScreen';
		this._Caption = this._Battle.Name;
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._ShowButtons = false;
		this._AutoDestroy = true;
	}

	_render()
	{
		super._render();
		this.addClass('edit-bout-statistics-dialog nopad');

		let columns: any[] = [];
		if (this._Battle.Type == SportType.Box)
			columns = getBoxEventsColumns();
		else
			columns = [{
				Content: 'Round',
				PropertyContent: 'Round',
				Width: '5%',
			}, {
				Content: 'Action',
				PropertyContent: 'Action',
				Width: '10%',
			}, {
				Content: 'Zone',
				PropertyContent: 'Zone',
				Width: '5%',
			}, {
				Content: 'Answer',
				PropertyContent: 'Answer',
				Width: '10%',
			}, {
				Content: 'Desc',
				PropertyContent: 'HLDesc',
				Width: '10%',
			}, {
				Content: 'Time',
				PropertyContent: 'Time',
				Width: '10%',
			}, {
				Content: 'World Time',
				PropertyContent: 'ActionTS',
				Width: '10%',
			}, {
				Content: 'GroundStart',
				PropertyContent: 'GroundStart',
				Width: '10%',
			}, {
				Content: 'GroundEnd',
				PropertyContent: 'GroundEnd',
				Width: '10%',
			}, {
				Content: 'GrappleStart',
				PropertyContent: 'GrappleStart',
				Width: '10%',
			}, {
				Content: 'GrappleEnd',
				PropertyContent: 'GrappleEnd',
				Width: '10%',
			}]

		if (NP.isAdmin())
		{
			this._topAppBar.addRightItem(new Button({
				RK: 'ClearAllBattleData',
				EvClick: () =>
				{
					NP.showConfirm({
						Content: 'Are you sure you want to delete all data of this Fight?',
						EvOkButtonClick: () => ServerAPI.post(`/battle/clearBattleData/${this._Battle.Id}`)
							 .then(() => this.hide())
					});
				}
			}))

			this._topAppBar.addRightItem(new CheckBox({
				Content: 'Online',
				EvClick: (cb: CheckBox) =>
				{
					this._isOnline = cb.getChecked()
					if (this._isOnline)
						this._onlineId = setTimeout(() => this.refreshDataTable(), 2000);
					else
						clearTimeout(this._onlineId)
				}
			}))

			this._topAppBar.addRightItem(new Button({
				Content: 'Refresh',
				EvClick: (cb: CheckBox) =>
				{
					this._lastLoadedEventId = null;
					if (!this._isOnline)
						this.refreshDataTable(true);
					else
						this._refreshAll = true;
				}
			}))
		}

		if (this._Battle.Type == SportType.MMA) {
			this._tabs = new TabControl({
				ParentNode: this._contentNode,
				Items: [
					{Value: 'General', Content: 'General'},
					{Value: 'Judge', Content: 'Judge'}
				],
				EvTabSelected: () => {
					switch (this._tabs.getValue()) {
						case 'General':
							this._dataTable.setIsVisible(true)
							this._judgePanel.setIsVisible(false)
							break;
						case 'Judge':
							this._dataTable.setIsVisible(false)
							this._judgePanel.setIsVisible(true)
							break;
					}
				}
			});
		}

		this._dataTable = new DataTable({
			ShowSettingsButton: true,
			ParentNode: this._contentNode,
			ShowPaginator: true,
			Columns: columns,
			EvPaginatorLeftClick: () =>
			{
				this._Offset -= this._Count;
				this.refreshDataTable();
			},
			EvPaginatorRightClick: () =>
			{
				this._Offset += this._Count;
				this.refreshDataTable();
			},
			EvItemClick: (s: any, e: { Item: MMAEvent | IBattleEvent }) => this.editEvent(e.Item),
			EvItemContextMenu: (s: any, e: { Event: any, Item: MMAEvent }) =>
			{
				let menu = new Menu({
					Items: [this._Battle.Type != SportType.Box && {
						FontImage: NP.FontImages.add,
						Content: 'Add here',
						Value: 'AddHere'
					}, {
						FontImage: NP.FontImages.edit,
						RK: 'Edit',
						Value: 'Edit'
					}, {
						FontImage: NP.FontImages.delete,
						RK: 'Delete',
						Value: 'Delete'
					}],
					EvItemSelected: async (s: Menu, event: { Item: any }) =>
					{
						switch (event.Item.getValue())
						{
							case 'AddHere':
								let newEv = {...e.Item} as unknown as MMAEvent;
								newEv.EventOrder = null;
								newEv.Answer = null;
								newEv.Action = null;
								newEv.Zone = null;

								(new EditMMAEventDialog({
									Event: newEv,
									Battle: this._Battle,
									EvSaved: () => this.refreshDataTable()
								})).show()

								break;
							case 'Delete':
								if (this._Battle.Type == SportType.Box)
									await ServerAPI.post(`/box/${e.Item.EventOrder}/deleteEvent`);
								else
									await ServerAPI.delet(`/mma/event/${e.Item.EventOrder}`);
								this.refreshDataTable(true)
								break;
							case 'Edit':
								this.editEvent(e.Item);
								break;
						}
					}
				});
				menu.showContextMenu(e.Event);
			}
		});

		this._okButton.setIsVisible(false)

		this.refreshDataTable();


		let btn = new Button({
			RK: 'SwapData',
			EvClick: () =>
			{
				NP.showConfirm({
					RK: 'AreYouS',
					EvOkButtonClick: async () =>
					{
						await ServerAPI.post(`/battle/changeCornersData/${this._Battle.Id}`);
						this.refreshDataTable()
					}
				}).show();
			}
		});

		btn.putToNode(this._dataTable.getPaginatorNode(), this._dataTable.getPaginatorNode().firstChild)

		btn.getRoot().style.marginRight = 'auto'
		btn.getRoot().style.marginLeft = '12px'

		if (this._Battle.Type == SportType.MMA) {
			this._judgePanel = new JudgePanel({
				ParentNode: this._contentNode,
				Height: 500,
				Battle: this._Battle,
				BattleId: this._Battle.GloryFightID,
				Round: 1
			})
			this._judgePanel.setIsVisible(false)
		}
	}

	hide()
	{
		clearTimeout(this._onlineId)
		super.hide();
	}

	setHeight(value?: number, fireEvents?: boolean)
	{
		super.setHeight(value, fireEvents);

		this._dataTable.setHeight(value - 120)
		if (this._judgePanel)
			this._judgePanel.setHeight(value - 120)
	}

	async refreshDataTable(refreshAll: boolean = false)
	{
		if (!this.isLive() || !this._IsVisible)
			return;

		let rowsData = [];
		if (this._Battle.Type == SportType.Box)
		{
			if (this._isOnline)
			{
				this._AllCount = 0;
				let lastParam = this._lastLoadedEventId ? `?lastLoadedEvent=${this._lastLoadedEventId}` : ''
				rowsData = await ServerAPI.get(`/box/getBattleEvents/${this._Battle.Id}${lastParam}`, false) as any[]
			}
			else {
				this._AllCount = await ServerAPI.get(`/box/getEventsCount/${this._Battle.Id}`) as number;
				rowsData = await ServerAPI.get(`/box/getBattleEvents/${this._Battle.Id}?count=${this._Count}&offset=${this._Offset}`) as any[]
			}
		}
		else
		{
			if (this._isOnline)
			{
				this._AllCount = 0;
				let lastParam = this._lastLoadedEventId ? `?lastLoadedEvent=${this._lastLoadedEventId}` : ''
				rowsData = await ServerAPI.get(`/mma/getAllMMAEvents/${this._Battle.Id}${lastParam}`, false) as any[]
			}
			else
			{
				this._AllCount = await ServerAPI.get(`/mma/getEventsCount/${this._Battle.Id}`) as number;
				rowsData = await ServerAPI.get(`/mma/getBattleEvents/${this._Battle.Id}?count=${this._Count}&offset=${this._Offset}`) as any[]
			}
		}



		if (rowsData.length) {
			this._lastLoadedEventId = rowsData[rowsData.length - 1].EventOrder
			if (this._judgePanel)
				this._judgePanel.setRound(rowsData[rowsData.length - 1].Round)
		}

		rowsData.forEach(row =>
		{
			row.CssClass = row.ActionAthleteId == this._Battle.Red ? 'red-row' : 'blue-row'
		})

		//rowsData.sort((a: MMAEvent | IBattleEvent, b: MMAEvent | IBattleEvent) => b.EventOrder - a.EventOrder);

		if (this._isOnline)
		{
			this._onlineId = setTimeout(() => this.refreshDataTable(), 2000);
			if (refreshAll || this._refreshAll)
			{
				this._dataTable.setRows(rowsData);
				this._refreshAll = null;
			}
			else
				this._dataTable.addRows(rowsData);
		}
		else
		{
			this._dataTable.updatePagCaption(this._Offset + " - " + ((this._Offset + this._Count) < this._AllCount ? this._Offset + this._Count : this._AllCount))
			this._dataTable.getLeftPagButton().setEnabled(this._Offset > 0);
			this._dataTable.getRightPagButton().setEnabled(this._Offset + this._Count <= this._AllCount);
			this._dataTable.setRows(rowsData);
		}
	}

	editEvent(event: MMAEvent | IBattleEvent)
	{
		if (this._Battle.Type == SportType.Box)
		{
			(new EditEventDialog({
				Event: event,
				Battle: this._Battle,
				EvSaved: () => this.refreshDataTable(true)
			})).show()
		}
		else
			(new EditMMAEventDialog({
				Event: event,
				Battle: this._Battle,
				EvSaved: () => this.refreshDataTable(true)
			})).show()
	}
}
